import {NORMAL_SCALE} from './scale_level';

export class Settings {
  constructor(
    public showOptionalFields: boolean = true,
    public scaleValue: number = NORMAL_SCALE,
  ) {}
}
